import * as Yup from 'yup';
import { Heart, Pill, Star } from 'lucide-react';
import { choiceBtnSelected, choiceBtnUnselected } from 'components/Profile/helper';

export const MEDICAL_GROUPS = [
  {
    name: 'allergies',
    title: 'Allergies',
    icon: Star,
    question: 'Any allergies we should know about?',
    prompt: 'Tell us which allergies',
  },
  {
    name: 'conditions',
    title: 'Medical conditions',
    icon: Heart,
    question: 'Any conditions we should know about?',
    prompt: 'Tell us which conditions',
  },
  {
    name: 'medications',
    title: 'Current medications',
    icon: Pill,
    question: 'Taking any medications right now?',
    prompt: 'Tell us which medications',
  },
];

export const YES_NO = [{ label: 'Yes', value: true }, { label: 'No', value: false }];

export const choiceBtnClass = (isSelected: boolean) =>
  `btn flex-1 rounded-xl sm:flex-none ${isSelected ? choiceBtnSelected : choiceBtnUnselected}`;

export function getInitialValues(attributes) {
  const { allergies, conditions, medications, have_no_medical_conditions, medical_notes = '' } = attributes || {}

  const toMap = (arr) => Object.fromEntries(
    arr?.data?.map(({ id, attributes: a }) => [id, a.status]) ?? []
  )

  const anyChecked = (group) => !!group?.data?.some(({ attributes: a }) => a.status)

  const saved = !!have_no_medical_conditions
    || !!medical_notes?.trim()
    || [allergies, conditions, medications].some(anyChecked)

  const answerFor = (group) => anyChecked(group) ? true : saved ? false : null

  return {
    have_no_medical_conditions,
    answers: {
      allergies: answerFor(allergies),
      conditions: answerFor(conditions),
      medications: answerFor(medications),
    },
    allergies: toMap(allergies),
    conditions: toMap(conditions),
    medications: toMap(medications),
    medical_notes,
    reviewed: false,
  }
};

export const validationSchema = Yup.object({
  have_no_medical_conditions: Yup.boolean().test(
    'medical-info-required',
    'Please select at least one condition, allergy, or medication, or fill in the "Anything Else" field.',
    function (value) {
      if (value) return true;
      const { allergies, conditions, medications, medical_notes } = this.parent;
      return [allergies, conditions, medications].some(group => Object.values(group).some(Boolean)) || !!medical_notes?.trim();
    }
  ),
  reviewed: Yup.boolean().oneOf([true], 'Required'),
});
